import { showConfirm, showError } from "./components/Swal";
import { Affiliate, ILogin, IThemeUpdate, TAuth } from "./types";
import { store } from "./app/store";
import { login, logOut, vmLogin } from "./slices/auth-slice";
import { useAppDispatch } from "./app/hooks";
import { fetchAffiliate } from "./slices/fetchAffiliate";
import { clearAffiliate } from "./slices/affiliateTheme";
import { setPreview } from "./slices/commonSlice/preview";
import { defaultThemeOptions } from "./defaultTheme";
import { publishButton } from "./slices/publisher/publisherSlice";
import { updateTheme } from "./slices/updateThemeSlice";
import { ThemeOptions } from "@mui/material";
import deepmerge from "deepmerge";
import { NEW_FIELD } from "./commonConstant";

export function HandleAPIError(error: any) {
  if (error?.code === "ERR_NETWORK") {
    showError("Error", "Error");
  } else {
    showError("Error", error?.message);
  }
}

export async function _getAffiliate(response: any) {
  let newData: Affiliate[] = [];
  response.forEach((data: any) => {
    let newAffiliate = {
      id: data.affiliateid,
      name: data.affiliatename,
    };
    newData.push(newAffiliate);
  });
  store.dispatch(fetchAffiliate(newData));
}

export function setByPath(obj: any, path: string, value: any) {
  const keys = path.split(".");
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (i === keys.length - 1) {
      current[key] = value;
    } else {
      current = current[key];
    }
  }
}

export async function HandlePublish(request: IThemeUpdate) {
  try {
    await store.dispatch(publishButton(request)).unwrap();
  } catch (error: any) {
    showError("Error", error.message);
  }
}

export async function HandleUpdateSaveTheme(
  username: string,
  sessionid: string,
  action: string,
  affiliateid: number | null,
  themeOptions: any
) {
  try {
    let themeData = themeOptions;
    if (typeof themeOptions === "object") {
      themeData = JSON.stringify(themeOptions);
    }

    const request: IThemeUpdate = {
      sessionid: sessionid,
      username: username,
      request: {
        affiliateid: affiliateid,
        action: action,
        theme: themeData,
      },
    };
    return await store.dispatch(updateTheme(request)).unwrap();
  } catch (error: any) {
    showError("Error", error.message);
  }
}

export function checkAuthenticationExpiry(): boolean {
  const state = store.getState();
  const { authStatus, loginTimestamp } = state.auth;

  if (!authStatus || !loginTimestamp) {
    return true;
  }

  const currentTime = new Date().getTime();
  const hoursElapsed = (currentTime - loginTimestamp) / (1000 * 60);

  if (hoursElapsed >= 55) {
    store.dispatch(logOut());
    return true;
  }

  return false;
}

export const performVMLogin = async () => {
  const state = store.getState();
  if (state.auth.authStatus) {
    try {
      const vmRequest: ILogin = {
        username: state.auth.username,
        password: state.auth.password,
      };
      const vmResponse = await store.dispatch(vmLogin(vmRequest)).unwrap();
      if (vmResponse?.status !== 0) {
        showError("Error", vmResponse?.statusMessage || "Login unsuccessful");
        return;
      }
      const request: ILogin = {
        username: state.auth.username,
        password: state.auth.password,
        privilege: state.auth.privilege,
        sessionid: vmResponse?.data?.sessionid,
      };
      await store.dispatch(login(request)).unwrap();
    } catch (error) {
      console.error("VM Login Process Error:", error);
      showError("Error", "VM Login Process Failed");
    }
  }
};

export const handleNewfield = (themeOptions: ThemeOptions): ThemeOptions => {
  // Create a new palette object
  const updatedPalette: any = { ...(themeOptions.palette || {}) };

  // Ensure each message type exists in the palette
  (Object.entries(NEW_FIELD) as any[]).forEach(
    ([messageType, defaultStyle]) => {
      if (!updatedPalette[messageType]) {
        updatedPalette[messageType] = defaultStyle;
      }
    }
  );

  return {
    ...themeOptions,
    palette: updatedPalette,
  };
};

export async function logout() {
  const state = store.getState();
  const publisherStatus = state.auth.publisher;

  store.dispatch(logOut());
  store.dispatch(clearAffiliate());
  if (publisherStatus) {
    window.open("http://localhost:3000?logout-sync=1");
  }
  // userStatus ? navigate("/user-login") : navigate("/");
}

export function getRedirectUrl() {
  const hostName = window.location.hostname;
  let currentPort;
  let domain;
  console.log("host-name", hostName);

  const parts = hostName.split(".");

  if (parts.length >= 2) {
    domain = parts[parts.length - 2];
  }
  console.log("host-name 3", domain);

  if (hostName === "localhost") {
    currentPort = "http://localhost:3000";
  } else if (domain === "reliablesoftjm" || domain === "mentem") {
    currentPort = `https://obi.reliablesoftjm.com`;
  } else currentPort = `https://booking.${domain}.com`;
  return currentPort;
}
